"use client";

import { CustomSelect } from "~/components/ui/CustomSelect";
export type SortBy = "none" | "in_asc" | "in_desc" | "out_asc" | "out_desc";
export type FilterBy = "all" | "sub-pro" | "sub-ultra";

interface SortFilterProps {
  sortBy: SortBy;
  setSortBy: (value: SortBy) => void;
  filterBy: FilterBy;
  setFilterBy: (value: FilterBy) => void;
}

export default function SortFilterUI({
  sortBy,
  setSortBy,
  filterBy,
  setFilterBy,
}: SortFilterProps) {
  return (
   <div className="mt-4 flex flex-wrap items-center gap-4">
      {/* فیلتر دسته‌بندی */}
      <CustomSelect
        options={[
          { value: "all", label: "همه اشتراک‌ها" },
          { value: "sub-ultra", label: "اشتراک اولترا" },
          { value: "sub-pro", label: "اشتراک پرو" },
        ]}
        value={filterBy}
        onChange={(val) => setFilterBy(val as FilterBy)}
        icon={<FilterIcon />}
      />

      {/* مرتب‌سازی */}
      <CustomSelect
        options={[
          { value: "none", label: "بدون مرتب‌سازی" },
          { value: "in_asc", label: "ارزان‌ترین ورودی" },
          { value: "in_desc", label: "گران‌ترین ورودی" },
          { value: "out_asc", label: "ارزان‌ترین خروجی" },
          { value: "out_desc", label: "گران‌ترین خروجی" },
        ]}
        value={sortBy}
        onChange={(val) => setSortBy(val as SortBy)}
        icon={<SortIcon />}
      />
    </div>
  );
}

const FilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#A4A4A4"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
  </svg>
);

const SortIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#A4A4A4"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <polyline points="19 12 12 19 5 12"></polyline>
  </svg>
);

const ChevronDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#A4A4A4"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);